import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { daysLabel } from "@/lib/ui";
import { ShieldCheck, AlertTriangle, XCircle } from "lucide-react";

export default function Garanties() {
  const navigate = useNavigate();
  const [reminders, setReminders] = useState([]);
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/reminders").then((r) => setReminders(r.data.filter((x) => x.category === "warranty")));
    api.get("/items").then((r) => setItems(r.data));
  }, []);

  const active = reminders.filter((r) => (r.days_left ?? 0) > 30);
  const soon = reminders.filter((r) => (r.days_left ?? 999) <= 30 && (r.days_left ?? 0) >= 0);
  const expired = reminders.filter((r) => (r.days_left ?? 0) < 0);
  const missing = items.filter((i) => ["product", "equipment"].includes(i.category) && !i.warranty_months);

  const Col = ({ title, icon: Icon, color, list, empty, testid }) => (
    <div className="omy-glass rounded-2xl p-5" data-testid={testid}>
      <div className="flex items-center gap-2 mb-4"><Icon size={18} style={{ color }} />
        <h2 className="font-display font-medium">{title}</h2>
        <span className="text-xs text-muted-foreground ml-auto">{list.length}</span></div>
      <div className="space-y-3">
        {list.length === 0 && <p className="text-xs text-muted-foreground">{empty}</p>}
        {list.map((r, i) => (
          <button key={r.id || i} onClick={() => r.item_id && navigate(`/app/memoire/${r.item_id}`)}
            className="w-full text-left rounded-xl bg-black/20 px-3 py-2.5 hover:bg-black/40 transition-colors">
            <p className="text-sm font-medium">{r.title?.replace("Fin de garantie — ", "") || r.name}</p>
            <p className="text-xs text-muted-foreground">{r.days_left != null ? daysLabel(r.days_left) : "info manquante"}</p>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Garanties</h1>
        <p className="text-muted-foreground text-sm mt-1">OMY suit tes garanties et te prévient avant l'expiration — sans jamais rien inventer.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Col title="Actives" icon={ShieldCheck} color="#10B981" list={active} empty="Aucune" testid="warranty-active" />
        <Col title="Expirent bientôt" icon={AlertTriangle} color="#F59E0B" list={soon} empty="Aucune" testid="warranty-soon" />
        <Col title="Expirées" icon={XCircle} color="#EF4444" list={expired} empty="Aucune" testid="warranty-expired" />
        <Col title="Infos manquantes" icon={AlertTriangle} color="#6B7280" list={missing} empty="Tout est renseigné" testid="warranty-missing" />
      </div>
    </div>
  );
}
